const expertise = {
    sub: "our expertise",
    heading: "Unparalleled Wedding Planning Experience & Expertise",
    content: "At Eternal Vows, we are committed to crafting unforgettable weddings. Our years of expertise and attention to detail ensure your special day is flawless, stress-free, and tailored to your vision.",
    points: [
        {
            id: 1,
            title: 'Event Design & Styling',
            progress: 90,
        },
        {
            id: 2,
            title: 'Vendor Coordination',
            progress: 95,
        },
        {
            id: 3,
            title: 'Budget Management',
            progress: 88,
        },
        {
            id: 4,
            title: 'Client Satisfaction',
            progress: 98,
        },
    ]
};

export default expertise;